import SEPA from './components/SEPA'

function App() {
  return (
    <SEPA />
  )
}

export default App
